import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isFieldInvalid(form: FormGroup, field: string, errorCode?: string): boolean {
  const control = form.get(field);
  if (!!control && control.touched) {
    if (!errorCode) {
      return control.invalid;
    }
    return control.hasError(errorCode);
  }
  return false;
}

export const PasswordStrengthValidator = function (control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';
  const minPasswordLength = 8;

  if (!value) {
    return null;
  }

  if (value.length > 0 && value.length < minPasswordLength) {
    return { passwordStrength: 'invalidPasswordLength' };
  }

  const upperCaseCharacters = /[A-Z]+/g;
  if (!upperCaseCharacters.test(value)) {
    return { passwordStrength: 'mustContainUppercase' };
  }

  const lowerCaseCharacters = /[a-z]+/g;
  if (!lowerCaseCharacters.test(value)) {
    return { passwordStrength: 'mustContainLowercase' };
  }

  const numberCharacters = /[0-9]+/g;
  if (!numberCharacters.test(value)) {
    return { passwordStrength: 'mustContainNumbers' };
  }

  const specialCharacters = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (!specialCharacters.test(value)) {
    return { passwordStrength: 'mustContainSpecialCharacter' };
  }
  return null;
};

export function PasswordMatchValidator(matchTo: string, reverse?: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.parent && reverse) {
      const c = (control.parent?.controls as any)[matchTo];
      if (c) {
        c.updateValueAndValidity();
      }
      return null;
    }
    return !!control.parent && !!control.parent.value && control.value === (control.parent?.controls as any)[matchTo].value
      ? null
      : { matching: true };
  };
}
